import { render, staticRenderFns } from "./MultipleImagesUploader.vue?vue&type=template&id=8185b41c&"
import script from "./MultipleImagesUploader.vue?vue&type=script&lang=js&"
export * from "./MultipleImagesUploader.vue?vue&type=script&lang=js&"
import style0 from "./MultipleImagesUploader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports